<template>
    <div class="text-center">
      <v-dialog v-model="dialog" persistent>
        <v-card>
          <v-card-title class="text-h5 blue lighten-0 darken-4 white--text">
            Confirmar eliminacion del periodo de seleccion:
          </v-card-title>
  
          <v-card-text> 
            
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>            
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" :disabled="loading" outlined @click="enviar()"> confirmar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
import { down_periodoSeleccion } from '@/views/oferta_academica/servicios/seleccionService.ts';


  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          tipos:[{id:'SELECCION', text:'Periodo de seleccion de programas'}],
          input: {},
        };
      }, 
      methods: {
        async openmodal(row) {
            this.input = {};
            this.input.id = row.id;
            this.loading = false;
            this.dialog = true;  
                
        },
        cerrar() { 
            this.dialog = false;
        },
        async enviar(){
            this.loading = true;
            const r = await down_periodoSeleccion(this.input)
            if(r && r.down_periodoSeleccion){
                window.console.log('>>>', r)
                this.dialog = false
                this.$emit('success')
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => {
                m += x.message
              });  
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }
            window.console.log('>>>', r)
            this.loading = false;
        },

         
      },
    };
  </script>
  